import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Paper } from '@mui/material';
import React from 'react';
import LoadingIndicator from '../LoadingIndicator';

function InsightTable({ title, subtitle, data = [], isLoading, columns, onRowClick, emptyMessage = 'No data available', sx = { width: '48%' } }) {
    return (
        <Stack spacing={2} p={3} boxShadow={2} backgroundColor='white' borderRadius="8px" sx={sx}>
            <Stack>
                <Typography variant="h6" fontWeight="600">
                    {title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {subtitle}
                </Typography>
            </Stack>
            {isLoading ? (
                <LoadingIndicator />
            ) : (
                <TableContainer 
                    component={Paper} 
                    elevation={0}
                    sx={{ 
                        maxHeight: '400px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px'
                    }}
                >
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow className='tableHeader'>
                                {columns.map((column) => (
                                    <TableCell 
                                        key={column.key} 
                                        sx={{ fontWeight: '600', backgroundColor: '#f8f9fa' }}
                                    >
                                        {column.header}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.length > 0 ? (
                                data.map((item) => (
                                    <TableRow 
                                        key={item.item_id} 
                                        sx={{ 
                                            ':hover': { 
                                                backgroundColor: '#f5f5f5', 
                                                cursor: 'pointer',
                                                transition: 'background-color 0.2s ease'
                                            }
                                        }} 
                                        onClick={() => onRowClick(item)}
                                    >
                                        {columns.map((column) => (
                                            <TableCell key={column.key} sx={column.key === 'item_name' ? { fontWeight: '500' } : {}}>
                                                {column.render ? column.render(item) : item[column.key]}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={columns.length} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                                        {emptyMessage}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </Stack>
    );
}

export default InsightTable;